import React, { useCallback, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faSearch } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Form, Button, ButtonGroup, Breadcrumb, InputGroup } from '@themesberg/react-bootstrap';

import { useDispatch, useSelector } from 'react-redux';
import { eventShowSaga } from 'reduxToolkit/actions';

import { EventTables } from 'components/Event/EventTables';
import { storeTypes } from '../types';
import { eventSingleShowSlice } from '../reduxToolkit/reducers';

const EventPage = () => {
    const dispatch = useDispatch();
    const { eventSingleShowReset } = eventSingleShowSlice.actions;
    const { eventSingleShowState } = useSelector((state: storeTypes.IStore) => state);
    const { isEventSingleShowSuccess } = eventSingleShowState;

    const [searchWord, setSearchWord] = useState('');

    const dispatchEvents = useCallback(
        (pageNumber: number, searchingWord: string) => {
            const payload = {
                page: pageNumber,
                search_word: searchingWord,
            };
            dispatch(eventShowSaga(payload));
        },
        [dispatch]
    );

    useEffect(() => {
        dispatchEvents(1, '');
    }, [dispatchEvents]);

    useEffect(() => {
        if (isEventSingleShowSuccess === true) {
            dispatch(eventSingleShowReset());
            dispatchEvents(1, '');
        }
    }, [isEventSingleShowSuccess]);

    return (
        <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0">
                    <Breadcrumb
                        className="d-none d-md-inline-block"
                        listProps={{ className: 'breadcrumb-dark breadcrumb-transparent' }}
                    >
                        <Breadcrumb.Item>
                            <FontAwesomeIcon icon={faHome} />
                        </Breadcrumb.Item>
                        {/*<Breadcrumb.Item>SPK</Breadcrumb.Item>*/}
                        <Breadcrumb.Item active>Events</Breadcrumb.Item>
                    </Breadcrumb>
                    {/*<h4>Events</h4>*/}
                </div>
                <div className="btn-toolbar mb-2 mb-md-0">
                    <ButtonGroup>
                        <a href="/events/add">
                            <Button variant="outline-primary" size="sm">
                                Add
                            </Button>
                        </a>
                    </ButtonGroup>
                </div>
            </div>

            <div className="table-settings mb-4">
                <Row className="justify-content-between align-items-center">
                    <Col xs={8} md={6} lg={3} xl={4}>
                        <InputGroup>
                            <InputGroup.Text>
                                <FontAwesomeIcon icon={faSearch} />
                            </InputGroup.Text>
                            <Form.Control
                                value={searchWord}
                                onChange={(e) => setSearchWord(e.target.value)}
                                type="text"
                                placeholder="Search"
                            />
                        </InputGroup>
                    </Col>
                </Row>
            </div>

            <EventTables dispatchEvents={dispatchEvents} />
        </>
    );
};

export default EventPage;
